import "./rental-page.js";
import { loadScript, loadStyle } from "./helpers.js";

const autoload = /#\/noleggio([/][123]?|)(\?id=[0-9]+)?$/.test(
  document.location.hash
);

const btn = document.getElementById("start-btn");
btn.addEventListener("click", (e) => {
  //stop event
  e.preventDefault();

  //fix intro height for perform fold effect
  const intro = document.querySelector(".intro");
  intro.style.height = `${intro.clientHeight}px`;

  //disable at first click
  btn.setAttribute("disabled", true);

  //add loader
  btn.classList.add("loading");

  //load app css and script
  loadStyle("/css/rental-app.css", {
    callback: () => {
      //navigate
      if (!autoload) document.location.hash = "/noleggio";

      //load core
      loadScript("/js/rental-app.js");
    },
  });
});

//check if need to open onload
if (autoload) btn.dispatchEvent(new Event("click"));
